import {$api} from "shared/api";

export const archiveApiary = async (apiaryId: string | undefined) => {
    if (!apiaryId) return -1;
    const http = await $api.delete<any>(`/apiaries/${apiaryId}`);
    return http.status
}

export const restoreApiary = async (apiaryId: string | undefined) => {
    if (!apiaryId) return -1;
    const http = await $api.post<any>(`/apiaries/${apiaryId}/restore`);
    return http.status
}